import React, { useEffect, useState } from 'react';
import { Timer } from 'lucide-react';
export const Countdown = () => {
  const [timeLeft, setTimeLeft] = useState({
    minutes: 14,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else {
          return {
            minutes: 14,
            seconds: 59
          }; // Reset for demo purposes
        }
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="flex flex-col items-center justify-center mb-6" data-id="element-230">
      <div className="flex items-center gap-2 text-red-400 mb-2 font-bold uppercase tracking-wider text-sm" data-id="element-231">
        <Timer className="w-4 h-4" data-id="element-232" />
        La oferta expira en:
      </div>
      <div className="flex items-center justify-center gap-2 text-3xl font-black text-white" data-id="element-233">
        <div className="bg-[#112236] px-4 py-3 rounded-lg border border-red-500/30 text-red-400 shadow-[0_0_15px_rgba(239,68,68,0.2)]" data-id="element-234">
          00
        </div>
        <span className="text-red-400" data-id="element-235">:</span>
        <div className="bg-[#112236] px-4 py-3 rounded-lg border border-red-500/30 text-red-400 shadow-[0_0_15px_rgba(239,68,68,0.2)]" data-id="element-236">
          {timeLeft.minutes.toString().padStart(2, '0')}
        </div>
        <span className="text-red-400" data-id="element-237">:</span>
        <div className="bg-[#112236] px-4 py-3 rounded-lg border border-red-500/30 text-red-400 shadow-[0_0_15px_rgba(239,68,68,0.2)]" data-id="element-238">
          {timeLeft.seconds.toString().padStart(2, '0')}
        </div>
      </div>
    </div>;
};